import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import auth from './auth/store'
import tenant from './tenant/store'
import sensor from './sensor/store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  viewLoading: false,
  snackBar: {
    show: false,
    text: '',
    closeText: ''
  }
}

const getters = {}

const mutations = {
  __reset (state) {
    state.viewLoading = false
    state.snackBar.show = false
    state.snackBar.text = ''
    state.snackBar.closeText = ''
  },
  setViewLoading (state, loading) {
    state.viewLoading = loading
  },
  snackBarShow (state, {text, closeText}) {
    state.snackBar.text = text
    state.snackBar.closeText = closeText
    state.snackBar.show = true
  },
  snackBarClose (state) {
    state.snackBar.show = false
  },
}

const actions = {}

const core = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

let store = new Vuex.Store({
  modules: {
    core,
    auth,
    tenant,
    sensor
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})

export function resetStore () {
  Object.keys(store._mutations).forEach(key => {
    if (key.endsWith('__reset')) {
      store.commit(key)
    }
  })
}

export default store
